<div class="modal-header">
  <h5 class="modal-title">Invoice Preview</h5>
  <button
    type="button"
    class="btn-close custom-btn-close"
    data-bs-dismiss="modal"
    aria-label="Close"
    (click)="onClose()"
  >
    <i class="ti ti-x"></i>
  </button>
</div>
<div #payslipContainerToExport id="payslip-container">
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <div class="row justify-content-between border-bottom mb-3">
            <div class="col-md-6">
              <div class="d-flex align-items-center">
                <div class="overflow-hidden mb-2" style="width: 100px; height: 50px">
                  <img
                    [src]="imageBaseUrl + payrollData.businessLogo"
                    class="h-100 w-auto d-block"
                    alt="logo"
                    style="object-fit: contain"
                  />
                </div>
              </div>
              <h4>{{ payrollData.businessName }}</h4>
              <p class="mb-1">{{ payrollData.businessAddress }}</p>
              <p class="mb-1">{{ businessLocation }}</p>
            </div>
            <div class="col-md-6">
              <div class="text-end mb-3">
                <p class="mb-0">Payout period</p>
                <p class="text-dark">
                  {{ payPeriodStartDate | date: 'MMM dd' }} to
                  {{ payPeriodEndDate | date: 'mediumDate' }}
                </p>
              </div>
            </div>
            <h5 class="text-center mt-4 mb-4">
              Invoice for the period of {{ payPeriodStartDate | date: 'MMM dd' }} to
              {{ payPeriodEndDate | date: 'mediumDate' }}
            </h5>
          </div>
          <div class="row border-bottom align-items-center mb-3">
            <div class="col-md-6">
              <div class="mb-3">
                <!--<p class="text-dark mb-2 fw-semibold">To</p>-->
                <div>
                  <p class="mb-1">
                    Name:
                    <span class="text-dark"
                      >{{ payrollData.employee.firstName }}
                      {{ payrollData.employee.lastName }}</span
                    >
                  </p>
                  <p class="mb-1">
                    Contractor ID:
                    <span class="text-dark">{{ payrollData.employee.empId }}</span>
                  </p>
                  <p class="mb-1">
                    Designation:
                    <span class="text-dark">{{
                      payrollData.employee.designation?.designationName
                    }}</span>
                  </p>
                  <p class="mb-1">
                    Date of Joining:
                    <span class="text-dark">{{
                      payrollData.employee.joiningDate | date: 'MMM dd, yyyy'
                    }}</span>
                  </p>
                  <p class="mb-1">
                    Date of Birth:
                    <span class="text-dark">{{
                      payrollData.employee.birthdate | date: 'MMM dd, yyyy'
                    }}</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <!--<p class="text-dark mb-2 fw-semibold">To</p>-->
                <div>
                  <p *ngIf="payrollData.basis !== basis.HOURLY" class="mb-1">
                    Total no. of Paid Days:
                    <span class="text-dark">{{
                      payrollData.calculationBreakdown.payableDays
                    }}</span>
                  </p>
                  <p *ngIf="payrollData.basis === basis.HOURLY" class="mb-1">
                    Total Work Hours:
                    <span class="text-dark">{{ payrollData.totalHours }}</span>
                  </p>
                  <p *ngIf="payrollData.basis !== basis.HOURLY" class="mb-1">
                    Payable Days:
                    <span class="text-dark">{{
                      payrollData.calculationBreakdown.payableDays - payrollData.lopDays
                    }}</span>
                  </p>
                  <p *ngIf="payrollData.basis !== basis.HOURLY" class="mb-1">
                    LOP Days: <span class="text-dark">{{ payrollData.lopDays }}</span>
                  </p>
                  <p class="mb-1">
                    Bank Name: <span class="text-dark">{{ payrollData.bankName }}</span>
                  </p>
                  <p class="mb-1">
                    Bank Account Number:
                    <span class="text-dark">{{ payrollData.bankAccountNumber }}</span>
                  </p>
                  <p class="mb-1">
                    PAN: <span class="text-dark">{{ payrollData.pan }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="row">
              <div class="col-md-6 d-flex flex-column">
                <div class="list-group mb-3 flex-grow-1 d-flex flex-column border">
                  <div class="list-group-item bg-light p-3 border-bottom-0">
                    <h6>Earnings</h6>
                  </div>
                  <ng-container *ngFor="let earning of payrollData.calculationBreakdown?.earnings">
                    <div *ngIf="earning.amount > 0" class="list-group-item">
                      <div class="d-flex align-items-center justify-content-between">
                        <p class="mb-0">{{ earning.name }}</p>
                        <h6 class="fw-medium">
                          {{ earning.amount | currency: currency : 'symbol' : '1.2-2' : 'en-IN' }}
                        </h6>
                      </div>
                    </div>
                  </ng-container>
                  <div class="list-group-item border mt-auto">
                    <div class="d-flex align-items-center justify-content-between">
                      <p class="mb-0 fw-bold">Total Earnings</p>
                      <h6 class="fw-medium">
                        {{
                          payrollData.calculationBreakdown.totalEarnings
                            | currency: currency : 'symbol' : '1.2-2' : 'en-IN'
                        }}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 d-flex flex-column">
                <div class="list-group mb-3 flex-grow-1 d-flex flex-column border">
                  <div class="list-group-item bg-light p-3 border-bottom-0">
                    <h6>Deductions</h6>
                  </div>
                  <div
                    *ngFor="let deduction of payrollData.calculationBreakdown?.deductions"
                    class="list-group-item"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                      *ngIf="deduction.amount > 0 && deduction.name !== 'LOP'"
                    >
                      <p class="mb-0">{{ deduction.name }}</p>
                      <h6 class="fw-medium">
                        {{ deduction.amount | currency: currency : 'symbol' : '1.2-2' : 'en-IN' }}
                      </h6>
                    </div>
                  </div>
                  <!--<div class="list-group-item" *ngIf="payrollData.tds > 0">
                    <div class="d-flex align-items-center justify-content-between">
                      <p class="mb-0">TDS</p>
                      <h6 class="fw-medium">
                        {{ payrollData.tds | currency: currency : 'symbol' : '1.2-2' : 'en-IN' }}
                      </h6>
                    </div>
                  </div>-->
                  <div class="list-group-item border mt-auto">
                    <div class="d-flex align-items-center justify-content-between">
                      <p class="mb-0 fw-bold">Total Deductions</p>
                      <h6 class="fw-medium">
                        {{
                          payrollData.calculationBreakdown.totalDeductions
                            | currency: currency : 'symbol' : '1.2-2' : 'en-IN'
                        }}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <p class="mb-0">
                Net Payout :
                <span class="text-gray-9 fw-medium">
                  {{
                    payrollData.grossPayout - payrollData.calculationBreakdown.totalDeductions
                      | currency: currency : 'symbol' : '1.2-2' : 'en-IN'
                  }}</span
                >
              </p>
              <p>
                Gross Payout :
                <span class="text-gray-9 fw-medium">
                  {{
                    payrollData.grossPayout | currency: currency : 'symbol' : '1.2-2' : 'en-IN'
                  }}</span
                >
              </p>
            </div>
            <div class="d-flex justify-content-center align-items-center">
              <p class="small">This is a system generated invoice and do not require signature.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="download" style="text-align: center; margin-bottom: 20px">
  <button (click)="downloadPayslipPDF()" class="btn btn-primary" [disabled]="!payrollData">
    Download as PDF
  </button>
</div>
